<template>
    <div class="panel__container">
        <header class="panel__header">
            <h2 class="panel__title">General</h2>
        </header>

        <table class="table">
            <thead>
                <th>Account name</th>
                <th>Storage used</th>
                <th>Storage limit</th>
                <th>Active team members</th>
                <th>Active single channel guests</th>
                <th>Active multi channel guests</th>
            </thead>
            <tbody>
                <tr>
                    <td>{{ currentTenant.display_name }}</td>
                    <td>{{ currentTenant.formatted_storage_used }}</td>
                    <td>{{ currentTenant.formatted_storage_limit }}</td>
                    <td>{{ currentTenant.team_members_count }}</td>
                    <td>{{ currentTenant.single_channel_guests_count }}</td>
                    <td>{{ currentTenant.multi_channel_guests_count }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
import currentTenantAware from '../../mixins/currentTenantAware'

export default {
    mixins: [currentTenantAware]
}
</script>
